import { createAsyncThunk } from "@reduxjs/toolkit";
import EmailVerificationService from "../../../api/services/emailVerification";

export const getVerificationStatus = createAsyncThunk(
  "emailVerification/getVerificationStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EmailVerificationService.getVerificationStatus();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to get verification status");
    }
  }
);

export const sendVerificationEmail = createAsyncThunk(
  "emailVerification/sendVerificationEmail",
  async (email, { rejectWithValue }) => {
    try {
      const response = await EmailVerificationService.sendVerificationEmail(email);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to send verification email");
    }
  }
);

export const resendVerificationEmail = createAsyncThunk(
  "emailVerification/resendVerificationEmail",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EmailVerificationService.resendVerificationEmail();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to resend verification email");
    }
  }
);

export const verifyEmail = createAsyncThunk(
  "emailVerification/verifyEmail",
  async (token, { rejectWithValue }) => {
    try {
      const response = await EmailVerificationService.verifyEmail(token);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to verify email");
    }
  }
);